<template>
  <div>
    <section class="content" v-if="provider">
      <div>
        <div class="row">
          <el-button @click="$router.go(-1)" style="display: inline-block; float: right; transition: all 1s; margin-right: 30px">
            <i class="fas fa-angle-left"></i>
            Volver
          </el-button>  
        </div>
        <el-tabs v-model="activeTab" type="border-card">
          <el-row style="height: 90px; padding-top: 20px; text-align: right;">
              <el-tag effect="dark" style="font-size: 18px;" :type="statusType">
                {{ getStatusNameOfTab() }}
              </el-tag>
            </el-row>

          <el-tab-pane label="Datos generales" name="generalData">
            
            <el-row style="height: 70px; text-align: justify;">
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Cuit: {{ provider.cuit }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Razón Social: {{ provider.company }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Nombre de Fantasía: {{ provider.companyName ? provider.companyName : '-' }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Servicios: 
                  <span v-for="(rubro, index) in provider.rubros" :key="rubro.idRubro">
                  {{rubro.nombre}}
                  <span v-if="(index + 1) < provider.rubros.length">
                    /
                  </span>
                </span>
              </el-col>
            </el-row>

            <el-row style="height: 70px;">
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                País: {{ countryName(provider.generalData.idCountry) }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Provincia: {{ provinceName(provider.generalData.idProvince) }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Ciudad: {{ provider.generalData.city }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Dirección: {{ provider.generalData.address + ' ' + provider.generalData.addressNumber }}
              </el-col>
            </el-row>

            <el-row style="height: 70px;">
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Teléfono: {{ provider.generalData.phone }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                E-mail pago: {{ provider.generalData.paymentEmail }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                E-mail recepción: {{ provider.generalData.receiptEmail }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Código postal: {{ provider.generalData.zipCode }}
              </el-col>
            </el-row>

            <el-row style="height: 70px;">
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Sujeto IVA: {{ provider.generalData.typeIVA }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Persona: {{ provider.generalData.personType }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Subtipo persona: {{ provider.generalData.personSubType === 'Otro' ? provider.generalData.personSubTypeOther :   (provider.generalData.personSubType ? provider.generalData.personSubType : '-') }}
              </el-col>
              <el-col :span="6">
                <i class="el-icon-caret-right"></i>
                Alta de AFIP: 
                <a v-if="provider.generalData.pdfAfip !== '0'" :href="provider.generalData.pdfAfip" target="_blank" style="padding-left: 20px">
                  <i class="fa fa-file-pdf-o"/> Ver
                </a>
              </el-col>
            </el-row>
          </el-tab-pane>
          

          <el-tab-pane label="Datos de pago" name="paymentData">
            <el-row style="height: 70px;">
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Sucursal ICBC: {{ bankBranchName(provider.paymentData.idBankBranch) ? bankBranchName(provider.paymentData.idBankBranch) : '-' }}
              </el-col>
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Banco: {{ bankName(provider.paymentData.idBank) }}
              </el-col>
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Número de cta: {{ provider.paymentData.accountNumber }}
              </el-col>
            </el-row>

            <el-row style="height: 70px;">
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Tipo de cta: {{ bankAccountName(provider.paymentData.idBankAccountType) }}
              </el-col>
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                CBU: {{ provider.paymentData.cbu }}
              </el-col>
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Constancia: 
                <a v-if="provider.paymentData.pdfBank !== '0'" :href="provider.paymentData.pdfBank" target="_blank" style="padding-left: 20px">
                  <i class="fa fa-file-pdf-o"/> Ver
                </a>
              </el-col>
            </el-row>
          </el-tab-pane>




          <el-tab-pane label="Datos impositivos" name="taxData">
            <el-divider> Ingresos Brutos </el-divider>
            <el-row style="height: 70px;">
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Constancia: 
                <a :href="provider.taxData.pdfIb" target="_blank" style="padding-left: 20px">
                  <i class="fa fa-file-pdf-o"/> Ver
                </a>
              </el-col>
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Tipo: {{ provider.taxData.ibType }}
              </el-col>
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                <el-dropdown @command="handlePdfsExempt">
                  <span :class="provider.taxData.pdfsExempt.length > 0  ? 'el-dropdown-link' : ''">
                    Constancia de exento<i class="el-icon-arrow-down el-icon--right" v-if="provider.taxData.pdfsExempt.length > 0"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(pdf, index) in provider.taxData.pdfsExempt" v-bind:key="pdf.idPdfExemption" :command="pdf.pdfExempt">PDF {{ index }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
            </el-row>

            <el-row style="height: 70px;">
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Regimen de convenio: {{ agreementRegimeTypeName(provider.taxData.idAgreementRegimeType) }}
              </el-col>
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                CM05:
                <a v-if="provider.taxData.pdfCM05" :href="provider.taxData.pdfCM05" target="_blank" style="padding-left: 20px">
                  <i class="fa fa-file-pdf-o"/> Ver
                </a>
                <span v-else> - </span>
              </el-col>
              <el-col :span="8">
                <i class="el-icon-caret-right"></i>
                Jurisdicción sede: {{ jurisdictionName(provider.taxData.jurisdictionHeadquarters) }}
              </el-col>
            </el-row>

            <el-row>
              <i class="el-icon-caret-right"></i>
              Jurisdicciones:
              <el-table
                v-if="false"
                :data="provider.taxData.jurisdictions"
                height="250"
                style="width: 100%"
                :disabled="true">
              </el-table>
            </el-row>

          </el-tab-pane>
          <div class="row text-center" v-if="provider[activeTab].idCompanyDataStatus === '1'">
            <el-divider> Aceptar datos </el-divider>
            <el-button type="danger" @click="rejectCompanyDataVisible = true"> Rechazar <i class="el-icon-close"></i></el-button>
            <el-button type="success" @click="acceptCompanyData()"> Aceptar <i class="el-icon-check"></i></el-button>
          </div>
        </el-tabs>
      </div>

    <el-dialog title="Rechazar datos" :visible.sync="rejectCompanyDataVisible" :fullscreen="false" :lock-scroll="true">
      Escriba el motivo por el cual rechaza los datos:
      <el-input
        type="textarea"
        :rows="4"
        style="margin-top: 20px;"
        maxlength="400"
        placeholder="Ingrese el motivo"
        :show-word-limit="true"
        v-model="newObservation">
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-on:click="rejectCompanyData()">
          Aceptar
        </el-button>
      </span>
    </el-dialog>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '../../api'

export default {
  data () {
    return {
      idCompany: this.$route.params.id,
      activeTab: 'generalData',
      types: ['warning', 'success', 'danger'],
      statusType: '',
      rejectCompanyDataVisible: false,
      newObservation: ''
    }
  },
  computed: {
    ...mapState([
      'user',
      'providers'
    ]),
    provider () {
      return this.providers.find(prov => prov.idCompany === this.idCompany)
    },
    statusList () {
      return this.$store.state.companyDataStatus
    }
  },
  methods: {
    handleCloseCompanyDataRejection () {
      this.newObservation = ''
    },
    acceptCompanyData () {
      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      })
      .then(() => {
        this.provider[this.activeTab].idCompanyDataStatus = '2'
        this.provider[this.activeTab].idUser = this.user.idUser
        this.updateCompanyData(this.activeTab, this.provider[this.activeTab])
      })
      .catch(() => {
      })
    },
    rejectCompanyData () {
      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo')
        return
      }
      this.$confirm('¿Está seguro que desea rechazar los datos por este motivo?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      })
      .then(() => {
        this.provider[this.activeTab].idCompanyDataStatus = '3'
        this.provider[this.activeTab].idUser = this.user.idUser
        this.provider[this.activeTab].observation = this.newObservation
        this.updateCompanyData(this.activeTab, this.provider[this.activeTab])
      })
      .catch(() => {
      })
    },
    updateCompanyData (dataType, data) {
      let idCompanyData
      switch (dataType) {
        case 'generalData':
          idCompanyData = data.idGeneralData
          break
        case 'paymentData':
          idCompanyData = data.idPaymentData
          break
        case 'taxData':
          idCompanyData = data.idTaxData
          break
      }
      this.$store.commit('START_LOADING')
      api.request('POST', 'api/generic/' + dataType + '/' + idCompanyData, JSON.stringify(data))
      .then(response => {
        this.rejectCompanyDataVisible = false
        this.newObservation = ''
        this.$store.commit('STOP_LOADING')
        this.provider[dataType] = response.data
        this.$message.success('Estado cambiado satisfactoriamente')
      })
      .catch(error => {
        console.log(error)
        this.$store.commit('STOP_LOADING')
        this.$message.danger('Error al cambiar el estado')
      })
    },
    getStatusNameOfTab () {
      let tabIdCompanyStatus = this.provider[this.activeTab].idCompanyDataStatus
      this.statusType = this.types[tabIdCompanyStatus - 1]
      return this.getStatusName(tabIdCompanyStatus)
    },
    getStatusName (idCompanyDataStatus) {
      return this.statusList.find(el => el.idCompanyDataStatus === idCompanyDataStatus).description
    },
    handlePdfsExempt (url) {
      var win = window.open(url, '_blank')
      win.focus()
    },
    agreementRegimeTypeName (idAgreementRegimeType) {
      let founded = this.$store.state.regimenTypes.find(reg => reg.idAgreementRegimeType === idAgreementRegimeType)
      return founded ? founded.agreementRegimeType : '-'
    },
    jurisdictionName (idJurisdictions) {
      return this.$store.state.jurisdictions.find(jur => jur.idJurisdictions === idJurisdictions).jurisdictions
    },
    countryName (idCountry) {
      return this.$store.state.countries.find(country => country.idCountry === idCountry).country
    },
    provinceName (idProvince) {
      return this.$store.state.provinces.find(prov => prov.idProvince === idProvince).province
    },
    bankBranchName (idBankBranch) {
      let founded = this.$store.state.bankBranches.find(bb => bb.idBankBranch === idBankBranch)
      return founded ? founded.bankBranch : '-'
    },
    bankName (idBank) {
      return this.$store.state.banks.find(el => el.idBank === idBank).bank
    },
    bankAccountName (idBankAccountType) {
      return this.$store.state.accountTypes.find(ac => ac.idBankAccountType === idBankAccountType).bankAccountType
    }
  },
  mounted () {
  },
  beforeMount () {
  }
}
</script>



// WEBPACK FOOTER //
// ProviderDetail.vue?ace71d62